const linksToModulePlanner = document.querySelectorAll('.js-jump-to-module-planner');

if (linksToModulePlanner.length) {
    [].forEach.call(linksToModulePlanner, link => {
        const sku = link.dataset.id;
        link.addEventListener('click', () => {
            const moduleLink = document.querySelector(`.module-planner-component a#${sku}`);
            if (moduleLink) {
                moduleLink.click();
            }
        });
    });
}